/**
 * Resolve denormalized trade_name for a trade_id using an in-memory catalog list.
 */
export function resolveTradeNameForAssignment(tradeId, trades = []) {
  if (!tradeId) {
    return null;
  }

  const match = (trades || []).find((trade) => trade.trade_id === tradeId);
  return match?.trade_name || null;
}

/**
 * Build profile update fields that keep trade_id and trade_name synchronized.
 */
export function buildTradeAssignmentFields(tradeId, trades = []) {
  if (!tradeId) {
    return {
      trade_id: null,
      trade_name: null,
    };
  }

  return {
    trade_id: tradeId,
    trade_name: resolveTradeNameForAssignment(tradeId, trades),
  };
}
